document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('#image-trail-container');
  const images = [...container.querySelectorAll('.trail-image')];
  let imgIndex = 0;
  let zIndex = 1;
  const threshold = 120;
  let lastMousePos = { x: 0, y: 0 };

  const preloadImages = () => {
    return Promise.all(
      images.map((img) => new Promise((resolve) => (img.onload = img.complete ? resolve() : resolve)))
    );
  };

  const getPointerPos = (event) => {
    if (event.touches && event.touches.length > 0) {
      return { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
    return { x: event.clientX, y: event.clientY };
  };

  const showNextImage = (mousePos) => {
    const containerRect = container.getBoundingClientRect();
    const relativeMousePos = {
      x: mousePos.x - containerRect.left,
      y: mousePos.y - containerRect.top,
    };

    const img = images[imgIndex];
    imgIndex = (imgIndex + 1) % images.length;
    zIndex++;

    gsap.killTweensOf(img);
    gsap
      .timeline()
      .set(img, {
        zIndex,
        opacity: 1,
        scale: 0,
        x: relativeMousePos.x - img.offsetWidth / 2,
        y: relativeMousePos.y - img.offsetHeight / 2,
      })
      .to(img, {
        duration: 0.4,
        scale: 1,
        x: relativeMousePos.x - img.offsetWidth / 2,
        y: relativeMousePos.y - img.offsetHeight / 2,
        ease: 'power1.out',
      })
      .to(
        img,
        {
          duration: 0.4,
          opacity: 0,
          scale: 0.5,
          ease: 'power2.in',
        },
        0.6
      );
  };

  const handleMouseMove = (event) => {
    const mousePos = getPointerPos(event);
    const containerRect = container.getBoundingClientRect();

    const isInsideContainer =
      mousePos.x >= containerRect.left &&
      mousePos.x <= containerRect.right &&
      mousePos.y >= containerRect.top &&
      mousePos.y <= containerRect.bottom;

    if (isInsideContainer) {
      const dist = Math.hypot(mousePos.x - lastMousePos.x, mousePos.y - lastMousePos.y);
      if (dist > threshold) {
        lastMousePos = mousePos;
        showNextImage(mousePos);
      }
    }
  };

  // Initialize animation
  preloadImages().then(() => {
    images.forEach((img) => (img.style.opacity = 0));
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('touchmove', handleMouseMove);
  });
});
